import { resources } from "@constants/hardcoded-strings";
import { TableSettingsTableTypes } from "@enums/table-settings-table-types";
import { FormattedAssertionFraudResult } from "@idw-types/data/assertion-fraud-result/assertion-fraud-result";
import { IdwTable } from "@containers/common/idw-table/idw-table";
import { PaginationContainer } from "@containers/common/pagination-container/pagination-container";
import { IdwTableContainer } from "@containers/common/idw-table-container/idw-table-container";
import styles from "./fraud-report-table-container.less";
import { createColumnHelper, getCoreRowModel, getPaginationRowModel, getSortedRowModel, TableState, useReactTable } from "@tanstack/react-table";
import { useDispatch } from "react-redux";
import { useMemo } from "react";
import { handleSetPaginationChange, handleSetSortingChange } from "@utils/react-table/react-table-util";

type FraudReportTableContainerProps = {
    assertionFraudResults: Array<FormattedAssertionFraudResult>;
    tableState: TableState;
};

export const FraudReportTableContainer = (props: FraudReportTableContainerProps) => {
    const { assertionFraudResults, tableState } = props;
    const dispatch = useDispatch();

    const columnHelper = createColumnHelper<FormattedAssertionFraudResult>();

    const columns = useMemo(() => ([
        columnHelper.accessor("assertion.shortName", {
            header: resources.tables.fraudReport.columns.name.header
        }),
        columnHelper.accessor("claimStatus", {
            header: resources.tables.fraudReport.columns.claimStatus.header
        }),
        columnHelper.accessor("riskLevel.label", {
            header: resources.tables.fraudReport.columns.riskLevel.header
        }),
        columnHelper.accessor("finalPolicyDecision", {
            header: resources.tables.fraudReport.columns.decision.header
        }),
        columnHelper.accessor("totalCount", {
            header: resources.tables.fraudReport.columns.total.header
        })
    ]), [assertionFraudResults]);

    const useTableResult = useReactTable({
        columns,
        data: assertionFraudResults,
        state: tableState,
        filterFns: null,
        sortDescFirst: false,
        autoResetPageIndex: true,
        onSortingChange: (sortingOrUpdateFn) => handleSetSortingChange(sortingOrUpdateFn, TableSettingsTableTypes.FRAUD_REPORT, tableState.sorting, dispatch),
        onPaginationChange: (paginationOrUpdateFn) => handleSetPaginationChange(paginationOrUpdateFn, TableSettingsTableTypes.FRAUD_REPORT, tableState.pagination, dispatch),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel()
    });

    return (
        <IdwTableContainer>
            <IdwTable
                id="fraud-report"
                useTableResult={useTableResult}
                className={styles.fraudReportTable}
                headerColumnKeyPrefix={"fraud-report"}
            />
            <PaginationContainer
                idPrefix="fraud-report"
                useTableResult={useTableResult}
            />
        </IdwTableContainer>
    );
};